
document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('#product-logo-block__area', {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        speed: 5000,
        freeMode: true,
  
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        grabCursor: true,
        breakpoints: {
            750: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
});
